export default "__VITE_ASSET__c2HsMM0O__"